const NEW_FEATURE_KEY = 'NEW_FEATURE';

export const getFromLocalStorage = (key) =>
  JSON.parse(localStorage.getItem(key));

export const addToLocalStorage = (key, value) =>
  localStorage.setItem(key, JSON.stringify(value)) || value;

export const addNewFeatureAccessedFlag = (featureKey, value = false) =>
  addToLocalStorage(`${NEW_FEATURE_KEY}-${featureKey}`, value);

export const getNewFeatureAccessedFlag = (featureKey) => {
  const flag = getFromLocalStorage(`${NEW_FEATURE_KEY}-${featureKey}`);
  return flag === null ? addNewFeatureAccessedFlag(featureKey, false) : flag;
};
